import { LeadingIndicator } from "@oldDashboard/legacyModels/leadingIndicador.model";
import { LeadingIndicatorSerializer } from "@oldDashboard/legacyModels/serializers/leadingIndicatorSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";
export class CommandConversionsLeadingIndicators {

    async run(affiliateId: String, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String) {  
        const path = `get-chart-data/client:summary-conversions-leading-indicators/?affiliate_id=${affiliateId}&launch_id=${launchSelected}&time_period=${timePeriodSelected}&start_date=${startDate}&end_date=${endDate}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success)
                return this.deserialize(response.chart_data);
            return null;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : LeadingIndicator {
        const serializer = new LeadingIndicatorSerializer();
        return serializer.deserialize(data);
    }
}

